import React from "react";
import classNames from "classnames";
import { Identifiable, Role } from "@planzone/dto";
import {
  useEditProjectResource,
  useRolesRetrieval,
} from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectedIcon } from "@common/selectedIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection(props: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();
  const { editProjectResource } = useEditProjectResource(props.projectResource);
  const isSelectedRole = (role: Identifiable<Role>) =>
    role.name.slice(0, "pr_".length) === "pr_";
  const editResourceRole = (role: Identifiable<Role>) =>
    editProjectResource({
      projectResource: props.projectResource,
      nextProjectResource: { ...props.projectResource, role },
    });

  return props.readOnly ? (
    <div className={classNames(styles.input, styles.readOnly)}>
      {props.projectResource.role ? (
        <p>
          {t(
            `roles.${props.projectResource.role.name}`,
            props.projectResource.role.name,
          )}
        </p>
      ) : (
        <p className={styles.textHidden}>e</p>
      )}
    </div>
  ) : (
    <SelectList
      rootClassName={styles.roleSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select }) => ({
        input: (
          <div
            className={classNames(styles.input, {
              [styles.openedInput]: isOpen,
            })}
          >
            {props.projectResource.role ? (
              <p>
                {t(
                  `roles.${props.projectResource.role.name}`,
                  props.projectResource.role.name,
                )}
              </p>
            ) : (
              <p className={styles.textHidden}>e</p>
            )}
            {isOpen ? (
              <div>
                <ArrowIcon className={styles.iconOpen} />
              </div>
            ) : (
              <ArrowIcon className={styles.iconClose} />
            )}
          </div>
        ),
        list: (
          <div className={styles.list}>
            {roles.filter(isSelectedRole).map((role, key) => (
              <div
                className={styles.role}
                key={key}
                onClick={() => select(editResourceRole(role))}
              >
                {props.projectResource.role.name === role.name ? (
                  <div className={styles.selectedRole}>
                    <div className={styles.selectedRoleTitle}>
                      {t(`roles.${role.name}`, role.name)}{" "}
                      <SelectedIcon className={styles.selectedRoleIcon} />
                    </div>
                  </div>
                ) : (
                  <div>{t(`roles.${role.name}`, role.name)}</div>
                )}
                <div className={styles.roleDescription}>
                  {t(`roles.description.${role.name}`, role.name)}
                </div>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { RoleSelection };
